import { apiClient } from '@slot-nx/core'
import { gameConfig } from '../../../config'
import { GameInfoResponse } from './GameInfoResponse'

export declare interface IGameInfoApi {
  getGameInfo(): Promise<GameInfoResponse>
}

export const gameInfoApi: IGameInfoApi = {
  async getGameInfo(): Promise<GameInfoResponse> {
    const response = await apiClient.post<GameInfoResponse>(`${gameConfig.name}/GameInfo`)
    return response.data
  },
}
